import { CopyButton } from "./CopyButton";

export function CodeBlock({ code, copyLabel = "Copy" }: { code: string; copyLabel?: string }) {
  return (
    <div className="relative rounded-lg border bg-muted">
      <pre
        tabIndex={0}
        className="overflow-auto rounded-lg p-3 pr-10 font-mono text-xs focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
      >
        {code}
      </pre>
      <div className="absolute right-1 top-1">
        <CopyButton value={code} label={copyLabel} />
      </div>
    </div>
  );
}
